<template>
  <v-card v-if="vehicle">
    <v-btn color="grey" small class="tariff-headers">
      <h3>{{ $i18n.t("Images") }}</h3>
    </v-btn>

    <v-row style="padding: 10px 10px">
      <v-container class="fill-height" fluid>
        <v-fade-transition mode="out-in">
          <v-row key="0">
            <v-col cols="12" sm="12" md="6" lg="4" v-if="vehicle.vehicleDetail.rcPic">
              <v-card>
                <a :href="vehicle.vehicleDetail.rcPic">
                  <v-img
                    v-if="isPDF(vehicle.vehicleDetail.rcPic)"
                    src="@/assets/pdf_format.png"
                    aspect-ratio="2"
                    class="grey darken-4"
                  ></v-img>
                  <v-img
                    v-else
                    :src="vehicle.vehicleDetail.rcPic"
                    aspect-ratio="2"
                    class="grey darken-4"
                  ></v-img>
                </a>
                <v-row class="px-2">
                  <v-col cols="12" md="12" lg="12">RC Pic</v-col>
                  <v-col cols="12" md="12" lg="12">RC No.: {{ vehicle.vehicleDetail.rcNo }}</v-col>
                  <z-confirm-button
                    class="close-button"
                    color="red"
                    fab
                    :loading="loading"
                    x-small
                    :message="
                      $i18n.t('Do you want to remove this attachment ?')
                    "
                    @click="deleteVehicleImage(1, vehicle._id, true)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </z-confirm-button>
                </v-row>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              md="6"
              lg="4"
              v-for="(picture, index) in vehicle.vehicleDetail.pictures"
              :key="index"
            >
              <v-card>
                <a :href="picture.url">
                  <v-img
                    v-if="isPDF(picture.url)"
                    src="@/assets/pdf_format.png"
                    aspect-ratio="2"
                    class="grey darken-4"
                  ></v-img>
                  <v-img v-else :src="picture.url" aspect-ratio="2" class="grey darken-4"></v-img>
                </a>
                <v-row class="px-2">
                  <v-col cols="12" md="12" lg="12">{{ picture.name }}</v-col>
                  <v-col cols="12" md="12" lg="12">
                    {{ picture.desc }}{{ picture.by }}
                    {{ picture.time | moment("HH:mm DD MMM YYYY") }}
                  </v-col>
                  <z-confirm-button
                    class="close-button"
                    color="red"
                    fab
                    :loading="loading"
                    x-small
                    :message="
                      $i18n.t('Do you want to remove this attachment ?')
                    "
                    @click="deleteVehicleImage(picture.time, vehicle._id)"
                  >
                    <v-icon>mdi-close</v-icon>
                  </z-confirm-button>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-fade-transition>
      </v-container>
    </v-row>
    <v-row style="padding: 10px 10px">
      <v-col cols="12" sm="6" md="6" lg="6">
        <v-file-input
          chips
          :label="$i18n.t('Attachments')"
          @change="handleFileUpload()"
          v-model="imageFile"
        ></v-file-input>
      </v-col>
      <v-col cols="12" sm="6" md="3" lg="3">
        <v-select :items="imageNames" v-model="imageName" item-text="name" item-value="value"></v-select>
      </v-col>

      <v-col cols="12" sm="12" md="3" lg="2">
        <v-btn v-if="imageFile" color="green lighten-2" small v-on:click="uploadImage">
          <h3>{{ $i18n.t("Upload File") }}</h3>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doPostForm } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component({
  name: "Photos",
  props: {
    value: {
      default: null,
    },
  },
})
export default class Photos extends Vue {
  vehicle = null;

  get loading() {
    return common.loading;
  }

  async mounted() {
    if (this.value) this.vehicle = this.value;

    if (!this.vehicle) this.vehicle = {};
    if (!this.vehicle.vehicleDetail) this.vehicle.vehicleDetail = {};
  }

  @Watch("value")
  onValueChange(newVal) {
    this.vehicle = newVal;
  }

  imageNames = [
    { name: "Vehicle Pic", value: "Vehicle Pic" },
    { name: "Registration Certificate", value: "Registration Certificate" },
    { name: "Front Image", value: "Front Image" },
    { name: "Back Image", value: "Back Image" },
    { name: "Side Image", value: "Side Image" },
    { name: "Side Image-2", value: "Side Image-2" },
    { name: "Interior Image-1", value: "Interior Image-1" },
    { name: "Interior Image-2", value: "Interior Image-2" },
    { name: "Interior Image-3", value: "Interior Image-3" },
    { name: "Other", value: "Other" },
  ];

  imageFile = null;
  handleFileUpload(files) {
    if (files) {
      this.imageFile = files[0];
    }
  }

  imageName = "Vehicle Pic";
  async uploadImage() {
    try {
      common.setLoading(true);
      const formData = new FormData();

      if (this.vehicle._id) {
        formData.set("_id", this.vehicle._id);
        formData.set("name", this.imageName);
      }
      if (this.isSet(this.imageFile)) {
        formData.append("file", this.imageFile);
      }
      const url = "/api/vehicle/" + this.vehicle._id + "/picture/save";
      await doPostForm(url, formData);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
      this.$emit("reload", true);
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }

  async deleteVehicleImage(time, vehicle_id, isRc) {
    common.setLoading(true);
    if (isRc || (time && vehicle_id)) {
      try {
        await doGet(
          "/api/vehicle/" +
            time +
            "/" +
            vehicle_id +
            "/delete/picture?rc=" +
            isRc
        );
        common.showMessage("Removed Successfully !");
        this.$emit("reload", true);
      } catch (e) {
        common.setError(e.message);
      }
    }
    common.setLoading(false);
  }

  isPDF(_url) {
    if (_url && _url.includes(".pdf")) {
      return true;
    }
    return false;
  }

  isSet(_key) {
    if (
      _key != null &&
      _key != undefined &&
      _key != "null" &&
      _key != "undefined" &&
      _key != ""
    ) {
      return true;
    }
    return false;
  }

  formatDate(date) {
    if (date) {
      const dateStr = date.toString();
      return (
        dateStr.substring(6, 8) +
        "-" +
        dateStr.substring(4, 6) +
        "-" +
        dateStr.substring(0, 4)
      );
    } else {
      return "";
    }
  }
}
</script>

<style scoped>
.tariff-headers {
  text-transform: none;
  color: #555;
  top: -10px;
  left: 10px;
  right: 0px;
  font-size: 12px;
}
.close-button {
  text-transform: none;
  color: rgb(255, 66, 66);
  bottom: 7px;
  /* top: -10px; */
  right: 0px;
  font-size: 12px;
  position: absolute;
  z-index: 100;
}
.tab-pane {
  display: none;
}
</style>